import React from 'react';
import { useTranslation } from 'react-i18next';
import { tidyName } from '../../utils/tidyName';

// WHO IS WHO (owner, 24 Sep 2026). On an appointment row a doctor sees two
// names — the patient's and a doctor's — and a bare name leaves them guessing
// which is which. Every such name renders as "Patient: Swetha Kumar" /
// "Doctor: Jeeva Ashokan": the label muted, the name strong.
//
// `tidy` turns a SHOUTED word into a capitalised one ("Swetha KUMAR" →
// "Swetha Kumar") and leaves mixed-case words ("McDonald", "Dr") alone.

export default function WhoLabel({ role, name, tidy = false, className = '', nameClassName = 'font-semibold text-gray-800', testId }) {
    const { t } = useTranslation();
    if (!name) return null;
    const label = role === 'doctor'
        ? t('common.doctor_label', 'Doctor')
        : t('common.patient_label', 'Patient');
    return (
        <span className={className} data-testid={testId}>
            <span className="font-normal text-gray-400">{label}:</span>{' '}
            <strong className={nameClassName}>{tidy ? tidyName(name) : name}</strong>
        </span>
    );
}
